import React from "react";

const SEOWhyChooseUs = () => {
  const features = [
    {
      title: "As Low as $0.0003/Backlink",
      desc: "Get Backlink for $0.0003, for some of our backlinks services, such as: social network profiles, forum profiles.",
      icon: "fas fa-coins",
    },
    {
      title: "Your Order is just for Few Cents",
      desc: "If the minimum quantity is 100 links, and the price is $0.0003, then your order will be for $0.03 (3 cents) only.",
      icon: "fas fa-hand-holding-usd",
    },
    {
      title: "Very Low Minimum Quantity",
      desc: "For SEnuke campaign minimum quantity is 1 campaign, otherwise minimum quantity is 50 or 100 links per order.",
      icon: "fas fa-chart-line",
    },
    {
      title: "Incredibly Fast",
      desc: 'Once the order is submitted, within 0-24 hrs. your order will start "processing", then delivered within 3-24 hrs.',
      icon: "fas fa-tachometer-alt",
    },
    {
      title: "Always At Your Fingertips",
      desc: "With our best-in-className dashboard, get 24x7 access to your campaigns, reports, todos, milestones, teams, and reports.",
      icon: "fas fa-mobile-alt",
    },
    {
      title: "More Than Just A SEO Company",
      desc: "We have handled the online marketing mandate for thousands of businesses, enabling them to focus on their core business processes.",
      icon: "fas fa-briefcase",
    },
  ];

  return (
    <div className="container space-2 space-md-3">
      <div className="w-md-80 w-lg-50 text-center mx-md-auto mb-9">
        <span className="d-block text-secondary font-size-1 font-weight-medium text-uppercase mb-2">
          Search Engine Optimization - Boost the world!
        </span>
        <h2 className="font-weight-medium">WHY CHOOSE US?</h2>
        <p>
          We offer best web promotion services with awesome features at very
          affordable prices
        </p>
      </div>
      <div className="row mb-6">
        {features?.map((data, id) => (
          <div className="col-sm-6 col-md-4 mb-7" key={id}>
            <div className="media align-items-center mb-2">
              <i className={`${data.icon} font-size-2 text-brand mr-3`}></i>
              <div className="media-body">
                <h4 className="h6 mb-0">{data.title}</h4>
              </div>
            </div>
            <p>{data.desc}</p>
          </div>
        ))}
      </div>
      <div className="text-center">
        <div className="mb-3">
          <a
            className="btn btn-primary btn-wide transition-3d-hover mb-2 mb-sm-0 mx-1"
            href="/contact"
          >
            Free SEO Consultation
          </a>
          <a
            className="btn btn-outline-primary btn-wide transition-3d-hover mb-2 mb-sm-0 mx-1"
            href="/signup"
          >
            Get Started Now
          </a>
        </div>
      </div>
    </div>
  );
};

export default SEOWhyChooseUs;
